import { type FC } from 'react';
import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { SquareCardForm, type SquareCardFormProps } from './Square/component';

interface ProviderFormViewMap {
  [PaymentProvider.Square]: FC<SquareCardFormProps>;
}

export const providerFormViewMap: ProviderFormViewMap = {
  [PaymentProvider.Square]: SquareCardForm,
};
